<template>
  <div class="form-item">
    <el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">
      <div slot="content">
        {{item.description}}
      </div>
      <img class="form-tooltip" :src="require('@/assets/question.png')"/>
    </el-tooltip>
    <el-form-item :label="item.label" :prop="item.prop" :rules="[{required: item.required}]">
      <div class="ve-select"
           v-bind:class="{ ve_disable: disabled }"
           @click="callSelect">
        {{showtext}}
        <i class="el-icon-arrow-right scan" style="opacity: .5"></i>
        <span style="color: rgb(198, 202, 209)" v-if="itemdata == ''">{{item.prompt || ''}}</span>
      </div>
    </el-form-item>
    <mt-actionsheet
        cancelText="cancel"
        closeOnClickModal="true"
        :actions="dataSource"
        v-model="sheetVisible">
    </mt-actionsheet>
  </div>
</template>


<script>
	import { mapGetters } from 'vuex'
	import utils from '@/utils'
	import callApp from '@/services/sdk'
	export default {
		name: 'base-data-info-widget',
		props: {
			editable: { type: Boolean },
			item: { type: Object },
			value: [String, Array, Object]
		},
		data() {
			return {
				sheetVisible: false,
				dataSource: [
					{
						name: this.$t('app.no_data'),
						value: -1
					}
				],
				rules: utils.generateFormRule(this.item)
			}
		},
		computed: {
			...mapGetters({
				batchList: 'getBatchList',
				formStatus: 'getFormStatus',
				dataPointType: 'getDataPointType'
			}),
			disabled() {
				return !this.item.editable
					|| (this.formStatus === 'submitedit'
						&& this.dataPointType === 'bind'
						&& this.currentRemote === 'Remote.SKUList')
			},
			showtext() {
				const filter = this.dataSource.filter(item => this.itemdata === item.value)[0]
				return filter && filter.name
			},
			itemdata: {
				get() {
					if (this.value && this.value[0] && this.value[0].uuid) {
						return this.value[0].uuid
					} else {
						return ''
					}
				},
				set(itemdata) {
					const filter = this.dataSource.filter(item => itemdata === item.value)[0]
					this.$emit('input', [{uuid: filter.value, datavid: filter.datavid}])
				}
			},
			currentRemote() {
				return this.item.dataSource.filter(item => item.indexOf('Remote') > -1)[0] || ''
			}
		},
		watch: {
			'batchList': function (a) {
				const dataSource = this.item.dataSource.filter(item => item.indexOf('Remote') > -1)
				if (!dataSource.length) return
				if (dataSource[0] === 'Remote.SKUBatchList') { // sku list
					if (a.length) {
						this.dataSource = a.map(item => {
							item.method = this.setValue
							return item
						})
					}
					const filter = a.filter(item => item.value === this.itemdata)
					if (!filter.length) {
						this.itemdata = ''
					}
				}
			},
		},
		mounted() {
			if (this.formStatus === 'init') {
				this.$emit('input', [])
			}
			const dataSource = this.item.dataSource.filter(item => item.indexOf('Remote') > -1)
			if (!dataSource.length) return
			if (dataSource[0] === 'Remote.SKUList') {
				callApp('getData', {
					type: 'dataSource.server.' + dataSource[0].split('.')[1].toLowerCase(),
					data: {}
				}, 'cbGetData')
				.then(data => {
					this.dataSource = data.skulist && data.skulist.map(sku => {
						return {
							name: sku.skuName + ` ( ${sku.skuCode || ''} ) `,
							value: sku.skuDataVid,
							method: this.setValue
						}
					})

					callApp('getData', {
						type: 'dataSource.server.' + 'skubatchlist',
						data: this.itemdata
					}, 'cbGetData')
					.then(data => {
						const value = data.skubatchlist && data.skubatchlist.map(skubatch => {
							return {
								name: skubatch.batchName,
								value: skubatch.dataUuid,
								dataVid: skubatch.dataVid
							}
						})
						this.$store.dispatch('setBatchList', value)
					})
				})
			}
		},
		methods: {
			callSelect() {
				if (this.disabled) {
					return
				}
				this.sheetVisible = true
			},
			setValue(select) {
				if (select.value === -1) return
				this.itemdata = select.value
			}
		}
	}
</script>